import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDisconnect(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12.005 4a7.501 7.501 0 0 1 7.012 4.823 4.67 4.67 0 0 1 3.483 4.51c0 2.579-2.098 4.667-4.685 4.667h-.628a.188.188 0 0 1-.187-.187v-1.4c0-.102.084-.186.188-.186h.627a2.895 2.895 0 0 0 .745-5.696l-.886-.233-.323-.852a5.75 5.75 0 0 0-2.065-2.644 5.692 5.692 0 0 0-3.281-1.031 5.692 5.692 0 0 0-3.282 1.031A5.746 5.746 0 0 0 6.66 9.446l-.326.854-.888.231a2.938 2.938 0 0 0-1.55 1.02 2.885 2.885 0 0 0 .204 3.796c.553.567 1.296.88 2.086.88h.628c.103 0 .187.084.187.186v1.4a.188.188 0 0 1-.188.187h-.627C3.598 18 1.5 15.912 1.5 13.333a4.672 4.672 0 0 1 3.492-4.512A7.5 7.5 0 0 1 12.005 4Zm2.702 10.293a1 1 0 0 1 0 1.414L13.414 17l1.293 1.293a1 1 0 0 1-1.414 1.414L12 18.414l-1.293 1.293a1 1 0 0 1-1.414-1.414L10.586 17l-1.293-1.293a1 1 0 1 1 1.414-1.414L12 15.586l1.293-1.293a1 1 0 0 1 1.414 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
